<script setup lang="ts"></script>

<template>
  <div class="service_address">
    <!-- Temporarily added here as we don't have the design yet for this component-->
    <!-- <SharedTwoStepVerification /> -->
  </div>
</template>

<style lang="scss" scoped></style>
